export default "__VITE_ASSET__C85KTfhf__"